import {
    useCreateController,
    CreateContextProvider,
    Form,
    SaveButton,
    useNotify,
    useTranslate,
    useRefresh
} from 'react-admin';

import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MUIButton
} from '@mui/material';

import { Resources } from '../resource';
import SmartMoneyForm from './SmartMoneyForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateMetadata = ({ onClose }: { onClose: () => void }) => {
    const notify = useNotify();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useCreateController({
        resource: Resources.smartMoney,
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.smartMoney.createSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    case 'SMART_MONEY_ALREADY_EXISTS':
                        notify(t('module.smartMoney.validate.conflict'), { type: 'error' });
                        break;
                    case 'METADATA_INVALID':
                        notify(t('module.smartMoney.validate.metadataInvalid'), { type: 'error' });
                        break;
                    default:
                        notify(t('module.smartMoney.unknownError'), { type: 'error' });
                        break;
                }
            }
        }
    });

    return (
        <CreateContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t("module.smartMoney.createSmartMoney")}</DialogTitle>
                <DialogContent>
                    <SmartMoneyForm isCreate />
                </DialogContent>
                <DialogActions>
                    <MUIButton variant="outlined" onClick={onClose}>
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="smart-money" action="create">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </CreateContextProvider>
    );
};

export default CreateMetadata;
